// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SubaccountsLinks_RefundResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for POST /payments/links/refund/{id}
 *
 * Returns the provider's refund-call result. The shape is owned downstream
 * by the subaccounts-service / payment provider.
 *
 * @deprecated The endpoint itself is deprecated; prefer refund_recebimento.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type SubaccountsLinks_RefundResponseDados = unknown[];

export type SubaccountsLinks_RefundResponse = ApiResponse<SubaccountsLinks_RefundResponseDados>;

registerResponseContract('SubaccountsLinks_RefundResponse', {})
